const notificationListPage = {
  title: "Notification Center",
  unreadBadge: "{{count}} unread",
  compose: {
    button: "Compose",
    title: "Send a notification to other users",
  },
  markAllAsRead: "Mark all as read",
  tabs: {
    all: "All",
    unreadOnly: "Unread only",
  },
  loading: "Loading notifications...",
  loadFailed: "Failed to load notifications",
  empty: {
    unread: "No unread notifications",
    all: "No notifications",
  },
  pagination: {
    pageOf: "Page {{current}} of {{total}}",
  },
};

export default notificationListPage;
